<template>
    <div>
        
        <PediatricDentistry />
    </div>
</template>

<script>

import PediatricDentistry from '../blog-details/PediatricDentistry.vue'

export default {
    components: {
       
        PediatricDentistry,
    }
}
</script>